export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Science, earth science, environmental science and geography teachers at middle school, high school and introductory college level, as well as homeschool educators.',
  ],
  [
    'Content depth?',
    'From the basics of weather, climate and the atmosphere to the evidence, impacts and responses, explained clearly for classroom teaching.',
  ],
  [
    'International?',
    'Yes. Based on internationally used scientific concepts and terminology; adapt it to your own curriculum and classroom.',
  ],
  ['Format?', 'Visual PDF files, ready to print or project, with instant access.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
